import React, { useState, useEffect } from 'react';
import 'boxicons/css/boxicons.min.css';
import './FooterSection.scss';
import logo from '../../../../assets/images/logo.png';
const FooterSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return (
        <footer className='footer-section'>
            <div className='footer-content'>
                <div className='footer-column logo-column'>
                    <img src={logo} alt="Company Logo" className="footer-logo" />
                </div>
                <div className='footer-columns-content'>
                    <div className='footer-column'>
                        <h3>
                            Head Office & Hours</h3>
                        <ul>
                            <li><i className='bx bx-phone' /><a href="#">(804) 220-5770</a></li>
                            <li><i className='bx bx-current-location' /><a href="#">2420 Maplewood Ave, Ste G
                                Richmond, VA 23220</a></li>
                            <li><i className='bx bx-briefcase' /><a href="#">Mon - Fri:
                                9:00AM - 5:00PM
                                <br />
                                Sat - Sun:
                                Closed</a></li>
                        </ul>
                    </div>
                    <div className='footer-column explore-column'>
                        <h3>Explore Our Practice</h3>
                        <ul>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/service">Our Services</a></li>
                            <li><a href="/careers-and-culture">Careers</a></li>
                            <li><a href="/contact-us">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='footer-bottom'>
                <p>&copy; 2023 Your Virginia Rehab Physicians. All rights reserved.</p>
            </div>
            {isVisible && (
                <div onClick={scrollToTop} className="scroll-to-top">
                    <i className='bx bx-up-arrow-alt'></i>
                </div>
            )}
        </footer>
    );
};

export default FooterSection;
